"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CourseContentDisclaimer = function CourseContentDisclaimer() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-body-sm-light text-black disclaimer"
  }, "Disclaimer: Tempest, which is now a part of Monument, may be mentioned at different points during the lesson. Tempest was formerly an independent online community for people on a sobriety journey, and this course has since been adapted from the Tempest platform.");
};
var _default = CourseContentDisclaimer;
exports.default = _default;